exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-file[data-v-0dfb41fe]{margin:0}.think .tabs[data-v-0dfb41fe]{position:fixed!important;top:0}", ""]);

// exports
